import * as React from "react";
import { useJoinDrawerUserExperience } from "../../providers";

import {
  JoinFormUi,
  JoinFormUiProps,
  JoinFormUi_PresentationOf_Tnc,
} from "../join-form-ui";

export interface StepJoinProps {
  useInitialState: JoinFormUiProps["useInitialState"];
}
export const StepJoin: React.FunctionComponent<StepJoinProps> = (props) => {
  const {
    handleUserWantsToLoginInsteadBecauseTheirEmailIsAlreadyRegistered,
    handleAlreadyAMemberSignIn,
  } = useJoinDrawerUserExperience();
  return (
    <section className="bbnt-common-join-drawer-fragment step-join">
      <img className="rewards-fancy-title-image" alt="REWARDS" />
      <h1 className="main-drawer-title">{`Join for Free`}</h1>
      <p>{`Receive exclusive member pricing, save your wishlists, checkout faster, and much more.`}</p>

      <JoinFormUi
        useInitialState={props.useInitialState}
        handleUserWantsToLoginInsteadBecauseTheirEmailIsAlreadyRegistered={
          handleUserWantsToLoginInsteadBecauseTheirEmailIsAlreadyRegistered
        }
        presentationOfTnc={JoinFormUi_PresentationOf_Tnc.ShortForm}
      />

      <AlreadyAMemberSignIn
        handleAlreadyAMemberSignIn={handleAlreadyAMemberSignIn}
      />
    </section>
  );
};

interface AlreadyAMemberSignInProps {
  handleAlreadyAMemberSignIn: () => void;
}
const AlreadyAMemberSignIn: React.FunctionComponent<
  AlreadyAMemberSignInProps
> = (props) => {
  return (
    <React.Fragment>
      <p className="already-a-member-sign-in">
        <span>{`Already a member? `}</span>
        <a
          onClick={props.handleAlreadyAMemberSignIn}
          href="javascript:void(0)"
        >{`Sign in.`}</a>
      </p>
    </React.Fragment>
  );
};
